import React from 'react';
export const TestimonialsSection = () => {
  return <section className="mb-10" data-id="element-204">
      <h2 className="text-4xl font-bold mb-4" style={{
      color: '#465866'
    }} data-id="element-205">
        Real Results from My Practice
      </h2>
      <p className="text-xl mb-6 italic" data-id="element-206">
        "Once I started recommending this approach, the transformations were so
        dramatic that other vets started asking what I was doing differently.
      </p>
      <div className="mb-8 pl-4" style={{
      borderLeft: '4px solid #76a0b4'
    }} data-id="element-207">
        <h3 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-208">
          Case Study #1: Max the Destroyer
        </h3>
        <p className="text-xl font-bold mb-2" data-id="element-209">Before:</p>
        <ul className="list-disc pl-6 mb-4 text-xl" data-id="element-210">
          <li className="mb-1" data-id="element-211">
            Golden Retriever destroying furniture during thunderstorms, on
            Trazodone for 8 months
          </li>
          <li className="mb-1" data-id="element-212">Lethargic and overweight from medication</li>
          <li className="mb-1" data-id="element-213">
            Still destructive during storms (medication wasn't even working)
          </li>
          <li className="mb-1" data-id="element-214">
            Owner spending $300/month on prescription and vet visits
          </li>
        </ul>
        <p className="text-xl font-bold mb-2" data-id="element-215">After PawEase:</p>
        <ul className="list-disc pl-6 mb-4 text-xl" data-id="element-216">
          <li className="mb-1" data-id="element-217">Calm during first storm while wearing vest</li>
          <li className="mb-1" data-id="element-218">Energy returned, lost excess weight</li>
          <li className="mb-1" data-id="element-219">Zero destruction in 6 months</li>
          <li className="mb-1" data-id="element-220">
            Owner saved thousands on medication and property damage
          </li>
        </ul>
        <div className="w-full h-[150px] bg-gray-200 mb-4 overflow-hidden" data-id="element-221">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/a5aJh4kuR53GtErmW8kE5K/GettyImages-1041987488-scaled-e1714713424901.jpg" alt="Happy dog being petted, showing relaxed and content expression" className="w-full h-full object-cover" style={{
          objectPosition: 'center 30%'
        }} data-id="element-222" />
        </div>
      </div>
      <div className="mb-8 pl-4" style={{
      borderLeft: '4px solid #76a0b4'
    }} data-id="element-223">
        <h3 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-224">
          Case Study #2: Luna's Separation Anxiety
        </h3>
        <p className="text-xl font-bold mb-2" data-id="element-225">Before:</p>
        <ul className="list-disc pl-6 mb-4 text-xl" data-id="element-226">
          <li className="mb-1" data-id="element-227">
            Border Collie with severe separation anxiety, prescribed Clomicalm
          </li>
          <li className="mb-1" data-id="element-228">Howling for hours when owner left</li>
          <li className="mb-1" data-id="element-229">Neighbors threatening to call animal control</li>
          <li className="mb-1" data-id="element-230">
            Side effects: digestive issues, reduced intelligence
          </li>
        </ul>
        <p className="text-xl font-bold mb-2" data-id="element-231">After:</p>
        <ul className="list-disc pl-6 mb-4 text-xl" data-id="element-232">
          <li className="mb-1" data-id="element-233">Sleeps peacefully when owner leaves</li>
          <li className="mb-1" data-id="element-234">
            Neighbors commented on the 'miraculous' change
          </li>
          <li className="mb-1" data-id="element-235">
            Full personality returned - solving puzzles and playing again
          </li>
        </ul>
      </div>
      <div className="mb-8 pl-4" style={{
      borderLeft: '4px solid #76a0b4'
    }} data-id="element-236">
        <h3 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-237">
          Case Study #3: Senior Dog Success
        </h3>
        <p className="text-xl font-bold mb-2" data-id="element-238">Before:</p>
        <ul className="list-disc pl-6 mb-4 text-xl" data-id="element-239">
          <li className="mb-1" data-id="element-240">
            12-year-old Beagle, owner hesitant about medication due to age
          </li>
          <li className="mb-1" data-id="element-241">Anxiety getting worse with age</li>
          <li className="mb-1" data-id="element-242">Traditional meds too risky for senior dogs</li>
          <li className="mb-1" data-id="element-243">Quality of life declining rapidly</li>
        </ul>
        <p className="text-xl font-bold mb-2" data-id="element-244">After:</p>
        <ul className="list-disc pl-6 mb-4 text-xl" data-id="element-245">
          <li className="mb-1" data-id="element-246">Gentle enough for senior dogs</li>
          <li className="mb-1" data-id="element-247">Anxiety reduced without health risks</li>
          <li className="mb-1" data-id="element-248">Owner says 'it gave us our dog back'</li>
        </ul>
      </div>
      <h3 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-249">
        What Owners Tell Me:
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6" data-id="element-250">
        <div style={{
        backgroundColor: '#e9f0f3'
      }} className="p-4 rounded-lg italic text-xl" data-id="element-251">
          'It's like having our old dog back'
        </div>
        <div style={{
        backgroundColor: '#e9f0f3'
      }} className="p-4 rounded-lg italic text-xl" data-id="element-252">
          'I wish we'd tried this before medication'
        </div>
        <div style={{
        backgroundColor: '#e9f0f3'
      }} className="p-4 rounded-lg italic text-xl" data-id="element-253">
          'The transformation was immediate'
        </div>
        <div style={{
        backgroundColor: '#e9f0f3'
      }} className="p-4 rounded-lg italic text-xl" data-id="element-254">
          'Finally, something that actually works'
        </div>
      </div>
      <h3 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-255">
        The Follow-Up Results:
      </h3>
      <p className="text-xl mb-4 italic" data-id="element-256">
        I've been tracking these cases for over two years now. The results
        remain consistent:
      </p>
      <ul className="list-disc pl-6 mb-6 text-xl" data-id="element-257">
        <li className="mb-1" data-id="element-258">Dogs maintain their calm response</li>
        <li className="mb-1" data-id="element-259">No tolerance issues (unlike medications)</li>
        <li className="mb-1" data-id="element-260">
          Owners report improved quality of life for entire family
        </li>
        <li className="mb-1" data-id="element-261">
          Many have been able to stop medications entirely"
        </li>
      </ul>
    </section>;
};